import { Heading } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import { FC } from 'react';
import { ProductType, StoreProductsList } from '@/entities/product';
import { DefaultContainer } from '@/shared/ui';

const ProductsBlock: FC<{ products: ProductType[] }> = ({ products }) => {
  const { t } = useTranslation();

  return (
    <DefaultContainer
      alignItems='center'
      gap='2xl'
    >
      <Heading size={{ base: 'xl', md: '2xl' }}>{t('store.product.youMayAlsoLike')}</Heading>
      <StoreProductsList products={products} />
    </DefaultContainer>
  );
};

export default ProductsBlock;
